import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import TelecomServices from "../components/home/TelecomServices";
import PrepaidPlans from "../components/PrepaidPlans";
const Telecom = () => {
    return (_jsxs("div", { className: "min-h-screen bg-neutral", children: [
        // Hero Section with Background Image
        _jsx("section", { 
            className: "relative h-[600px] bg-cover bg-center bg-no-repeat", 
            style: { backgroundImage: "url('/images/koodo.png')" },
            children: _jsx("div", { className: "absolute inset-0 bg-black/50 flex items-center", children: 
                _jsx("div", { className: "container mx-auto px-4 text-center", children: 
                    _jsxs("div", { className: "text-white", children: [
                        _jsx("h1", { className: "text-4xl md:text-5xl font-bold mb-4", children: "Telecom Services" }),
                        _jsx("p", { className: "text-xl md:text-2xl max-w-3xl mx-auto", children: "Connect with the best telecom providers for your mobile needs" })
                    ]})
                })
            })
        }),
        // Main Content
        _jsxs("div", { className: "container mx-auto px-4 py-12", children: [
            _jsx(TelecomServices, {}),
            _jsx(PrepaidPlans, {})
        ]})
    ]}));
};
export default Telecom;
